"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconReliability = function SvgIconReliability(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "reliability icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Reliability Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.633 6c9.723 0 17.632 6.6 17.632 14.7a12.109 12.109 0 01-.327 2.757.367.367 0 01-.585.204 12.936 12.936 0 00-8.032-2.7c-6.554 0-11.885 4.593-11.885 10.238a8.914 8.914 0 00.718 3.485.368.368 0 01-.387.508 20.042 20.042 0 01-3.29-.718l-.46-.148-8.037 3.582a.735.735 0 01-1.024-.79l.021-.092 2.086-6.954A13.288 13.288 0 016 20.705C6 12.602 13.91 6 23.633 6zM15.6 21.652a1.104 1.104 0 00-1.566 1.557 9.849 9.849 0 005.042 2.71l.274.05h.008a1.103 1.103 0 00.375-2.172 7.673 7.673 0 01-4.133-2.145zm10.608-8.872a1.103 1.103 0 012.2.1v2.942l-.004.1a1.103 1.103 0 01-2.2-.1v-2.941l.004-.1zm-7.155-.888a1.102 1.102 0 00-1.664.88l-.001.108v2.942a1.102 1.102 0 002.195.103l.009-.103v-2.941a1.103 1.103 0 00-.54-.99zM42 31.198c0-4.426-4.343-8.026-9.68-8.026-5.338 0-9.68 3.6-9.68 8.032 0 5.175 5.989 9.288 12.424 7.69l5.136 2.562.09.037a.735.735 0 00.944-.906L39.91 36.18l.169-.176A7.215 7.215 0 0042 31.2zm-8.077-.062a1.47 1.47 0 110 .242l-.005-.124.005-.118zm-4.975-1.241a1.47 1.47 0 00-.902 1.24l-.005.119.005.123a1.468 1.468 0 001.463 1.345 1.47 1.47 0 10-.561-2.827z"
  }));
};

var _default = SvgIconReliability;
exports.default = _default;